export const Route = {
  route: '',

  setRoute(newRoute) {
    this.route = newRoute;
  },

  getRoute() {
    return this.route;
  }

};